module.exports = __webpack_public_path__ + "static/performance-4dc330bb927faf71cde6abf3345c4554.png";